import Vue from 'vue';
import BaseFilter from '../../general/readableids/readableidsfilter';
import axios from 'axios';
import qs from 'qs';
import debounce from 'debounce';

export default Vue.component('outsourcersfilter', {
    extends: BaseFilter,
    data(){
        return {
            outsourcersService: axios.create({
                baseURL: '/webapi/outsourcersservice',
                paramsSerializer: function(params) {
                    return qs.stringify(params, { indices: false, allowDots: true, skipNulls: true })
                }
            })
        }
    },
    methods:{
        getFilterData: debounce(function (event) {
            var code = event.target.value !== null ? `${this.prefix}${event.target.value}` : '';

            this.outsourcersService.get('filteroutsourcers', {
                    params: { servicePointCode: code }
                }).then((response) => { 
                    this.validationErrors = code !== this.prefix ? response.data == null || response.data.id == null : false;
                    this.$emit('input', response.data != null ? response.data.id : '');
                    this.$emit('update:description', response.data != null ? response.data.name : '');
                    this.$emit('update:text', event.target.value);
                }).catch((thrown) => {
                    this.validationErrors = true;
                    console.log('app error', thrown.message);
                });
          }, 300)
    }
});